import React from "react";
import { Checkbox, Radio, RadioGroup } from "@opendate-app/setlist";
import { useMembershipProductNewContext } from "./MembershipProductNewContainer";
import { checkedFrom } from "./formControls";
import { annualEquivalentCents } from "./membershipFormLogic";
import { dollars } from "./FanPreview";

const OPTIONS = [
  ["any", "Any other membership", "Higher price is an upgrade, lower price is a downgrade."],
  ["some", "Only the ones I pick", "For memberships that sit outside your main levels."],
  ["none", "Nothing", "A standalone membership. Members can't switch online."],
];

const SwitchToField = () => {
  const { membershipProduct, otherMembershipProducts, updateMembershipProduct } = useMembershipProductNewContext();
  const switchTo = membershipProduct.switch_to || "any";
  const pickedIds = membershipProduct.switchable_membership_product_ids || [];
  const ownCents = annualEquivalentCents(membershipProduct);
  const others = [...otherMembershipProducts].sort((a, b) => a.annual_equivalent_cents - b.annual_equivalent_cents);
  const direction = (cents) => (cents > ownCents ? "upgrade" : cents < ownCents ? "downgrade" : "same price");

  const togglePicked = (id, checked) =>
    updateMembershipProduct({
      switchable_membership_product_ids: checked ? [...pickedIds, id] : pickedIds.filter((picked) => picked !== id),
    });

  return (
    <fieldset className="membership-field membership-switch-to">
      <legend className="membership-label">Members can switch to</legend>
      <RadioGroup name="membership-switch-to" value={switchTo} onChange={(value) => updateMembershipProduct({ switch_to: value })}>
        {OPTIONS.map(([value, title, description]) => (
          <div key={value} className="membership-switch-option">
            <Radio id={`membership-switch-to-${value}`} value={value} label={title} />
            <p className="membership-hint membership-switch-hint">{description}</p>
            {value === "some" && switchTo === "some" ? (
              <div className="membership-switch-list">
                {others.length ? (
                  others.map((other) => (
                    <Checkbox
                      key={other.id}
                      id={`membership-switch-pick-${other.id}`}
                      label={`${other.name} · ${dollars(other.annual_equivalent_cents)}/year · ${direction(other.annual_equivalent_cents)}`}
                      checked={pickedIds.includes(other.id)}
                      onChange={(checked) => togglePicked(other.id, checkedFrom(checked))}
                    />
                  ))
                ) : (
                  <p className="membership-hint">No other memberships yet.</p>
                )}
              </div>
            ) : null}
          </div>
        ))}
      </RadioGroup>
    </fieldset>
  );
};

export default SwitchToField;
